import React from "react";
import { useState, useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import api from "../../../services/api";
import { Row, Col, Form } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import IcLixo from "../../../components/Svg/IcLixo";
import IcFormando from "../../../components/Svg/IcFormando";
import DatePicker from "../../../components/DatePicker";
import styleButton from "../../../components/Button/Button.module.css";
import styleAccordeon from "../../../components/Accordeon/style.module.css";
import budgetStyle from "../../Business/styles.module.css";
import Slct from "../../../components/Slct";
import Checkbox from "../../../components/Checkbox";
import TabNotification from "../../../components/TabNotification";
import { ModalConfirm } from "../../../components/Modal";
import Loading from "../../../components/Loading";
import { Currency, IntegerNumber } from "../../../components/Input";
import getCommercial from "../../../util/getCommercial";
import getResource from "../../../util/getResource";
import Accordion from "../../../components/Accordion";
import Logo from "../../../components/Logo";
import useWrapper from "../../../hooks/useWrapper";
import TableResponsive from "../../../components/TableResponsive";
import useFormat from "../../../hooks/utils/useFormat";
import Button from "../../../components/Button";
import { PrintPage } from "../../../components/PrintPage";
import Tooltip2 from "../../../components/Tooltip";
import printRules from "../../../components/PrintRules/style.module.scss";
import { InputText, TextArea } from "../../../components/Input";
import SpoilerLink from "../../../components/SpoilerLink";
import style from "./style.module.css";
import Results from "../../../components/Results";
import ListItem from "../../../components/ListItem";
import InfoModal from "../../../components/InfoModal";
import TotalGenerate from "../../../components/InfoFinancialDetails/totalGenerate";
import TotalPaid from "../../../components/InfoFinancialDetails/totalPaid";
import PackageCard from "../../../components/PackageCard";
import { validateForm } from "../../../components/ValidateForm";
import Required from "../../../components/Required";

export default function NewBudget() {
  const { setbreadcrumb, me, config } = useWrapper();

  const { formatReal, stringToDate } = useFormat();
  const [loadingPage, setLoadingPage] = useState(true);
  const [reload, setreload] = useState(false);

  const { commercialId, budgetSelect } = useParams();
  const isNewBudget = useLocation().pathname.indexOf("newbudget") > -1;

  const [showModalSubmit, setshowModalSubmit] = useState(false);
  const [showModalUpdate, setshowModalUpdate] = useState(false);
  const [disableModalClick, setdisableModalClick] = useState(false);

  const [contributionToDelete, setcontributionToDelete] = useState([]);
  const [removalToDelete, setremovalToDelete] = useState([]);

  const confirmSubmit = async props => {
    const { update_values } = props;

    try {
      setdisableModalClick(true);
      let _resources_to_send = [];
      selectas.budget.events.forEach(__event => {
        __event.resources.forEach(__resource => {
          _resources_to_send.push({
            description: __resource.description,
            event_id: __resource.event_id,
            provider_id: __resource.provider_id,
            qtd: __resource.qtd || 0,
            resource_id: __resource.resource_id,
            single_value: __resource.single_value,
            show: __resource.show,
          });
        });
      });

      let _budget_packages_to_send = selectas.budget.packages
        .map(__package => {
          return {
            package_id: __package.id,
            advisory: __package.advisory,
            reserve_fund: __package.reserve_fund,
          };
        })
        .concat(
          selectas.budget.singles.map(__single => {
            return {
              package_single_id: __single.id,
              advisory: __single.advisory,
              reserve_fund: __single.reserve_fund,
            };
          }),
        );

      let _packages_to_send = selectas.budget.packages.map(__package => {
        const _package_values = getPackageValue(__package?.id);
        return {
          id: __package.id,
          number_trainees: __package.number_trainees,
          ...(!!update_values
            ? {
                value_original: _package_values?.total || 0,
                value_per_trainee_original: _package_values?.per_trainee || 0,
                number_of_trainees_original: _package_values?.number_trainees_original || 0,
              }
            : {}),
        };
      });

      let _singles_to_send = selectas.budget.singles.map(__single => {
        const _single_values = getSingleValue(__single?.id);
        return {
          id: __single.id,
          number_trainees: __single.number_trainees,
          ...(!!update_values
            ? {
                value_original: _single_values?.total || 0,
                value_per_trainee_original: _single_values?.per_trainee || 0,
                number_of_trainees_original: _single_values?.number_trainees_original || 0,
              }
            : {}),
        };
      });

      const { data: _budget } = await api.put(
        `budget/${commercial.budget.selected.id}`,
        {
          commercial_id: commercial.id,
          name: selectas.budget.name,
          description: selectas.budget.description,
          main: 1,
          resources: _resources_to_send,
          payments: [],
          budgetPackages: _budget_packages_to_send,
          packageUpdate: _packages_to_send,
          packageSingleUpdate: _singles_to_send,
          aporte: selectas.budget.aporte,
          retirada: selectas.budget.retirada,
        },
        config,
      );

      await api.post(
        "activity",
        {
          message: `Planilha de Custos <b>${!!_budget?.name ? ` - ${_budget?.name}` : ""} ${_budget.id}</b> atualizad${
            isNewBudget ? "o" : "a"
          }`,
          user_id: me?.id,
          commercial_id: commercialId,
          type: "act",
        },
        config,
      );

      await api.post(
        "contribution",
        {
          contribution: selectas.wallet.contribution.map(__contribution => ({
            commercial_id: commercialId,
            contribution: __contribution.type,
            description: __contribution.description,
            due_date: __contribution.due_date,
            id: __contribution.id,
            protocol_attendance: __contribution.protocol_attendance,
            user_id: __contribution.user_id,
            value: __contribution.cost,
            trainees: __contribution?.trainees?.map(__trainee => __trainee.value) || [],
          })),
          contributionForDelete: contributionToDelete || [],
        },
        config,
      );
      await api.post(
        "removal",
        {
          removal: selectas.wallet.removal.map(__removal => ({
            commercial_id: commercialId,
            removal: __removal.type,
            description: __removal.description,
            due_date: __removal.due_date,
            id: __removal.id,
            protocol_attendance: __removal.protocol_attendance,
            user_id: __removal.user_id,
            value: __removal.cost,
          })),
          removalForDelete: removalToDelete || [],
        },
        config,
      );
      toast.success("Planilha de Custos atualizada com sucesso!");
    } catch (__error) {
      toast.error("Erro ao tentar enviar os dados.");
      console.log("__error", __error);
    } finally {
      setshowModalSubmit(false);
      setshowModalUpdate(false);
      setdisableModalClick(false);
      setreload(!reload);
    }
  };

  const [commercial, setcommercial] = useState(null);
  const [resources, setresources] = useState(null);
  const [generatedValues, setgeneratedValues] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoadingPage(true);
        const _commercial = await getCommercial(commercialId, budgetSelect);
        setcommercial(_commercial);
        const _resources = await getResource();
        setresources(_resources);
        const { data: _generated } = await api.get(`total-amount-generated-per-commercial/${commercialId}`, config);
        setgeneratedValues(_generated);
      } catch (__error) {
        console.log(__error);
        toast.error("Erro ao carregar dados, tente novamente.");
      } finally {
        setLoadingPage(false);
      }
    })();
  }, [reload]);

  const [selectas, setselectas] = useState(null);

  useEffect(() => {
    if (commercial) {
      const _selectas = {
        budget: {
          name: commercial?.budget?.selected?.name,
          description: commercial?.budget?.selected?.description,
          main: commercial?.budget?.selected?.main,
          packages: commercial?.packages_data?.packages,
          events: commercial?.packages_data?.events?.concat([
            {
              id: null,
              name: "Sem Eventos",
              resources: [],
              number_trainees: { total: 0 },
            },
          ]),
          singles: commercial?.packages_data?.singles,
          payments: null,
          aporte: commercial?.budget?.selected?.aporte,
          retirada: commercial?.budget?.selected?.retirada,
        },
        wallet: {
          removal: commercial?.wallet?.removal?.data?.map(__removal => {
            let _due_date = __removal?.due_date ? stringToDate(__removal?.due_date) : "";
            _due_date = isNaN(_due_date.getTime()) ? "" : _due_date;
            return {
              ...__removal,
              due_date: _due_date,
            };
          }),
          contribution: commercial?.wallet?.contribution?.data?.map(__contribution => {
            let _due_date = __contribution?.due_date ? stringToDate(__contribution?.due_date) : "";
            _due_date = isNaN(_due_date.getTime()) ? "" : _due_date;
            return {
              ...__contribution,
              due_date: _due_date,
            };
          }),
        },
        updated_at: stringToDate(commercial?.updated_at),
      };
      setselectas(_selectas);
    }
  }, [commercial]);

  const [packagesTab, setpackagesTab] = useState(null);

  useEffect(() => {
    if (commercial?.institution?.name && selectas?.budget?.name) {
      if (commercial.is_class) {
        setbreadcrumb([
          { label: "Turmas", url: "/groups" },
          {
            label: commercial?.label,
            url: `/groups/${commercial.id}/registrationdata`,
          },
          {
            label: `${selectas?.budget?.name} - ${commercial?.budget?.selected?.id || "(Novo)"}`,
          },
        ]);
      } else {
        setbreadcrumb([
          { label: "Comercial", url: "/business" },
          {
            label: commercial.institution.name,
            url: `/business/feed/${commercial.id}`,
          },
          {
            label: `${selectas?.budget?.name} - ${commercial?.budget?.selected?.id || "(Novo)"}`,
          },
        ]);
      }
    }
  }, [commercial, selectas?.budget?.name]);

  const updateResource = ({ event_i, resource_i, key, value }) => {
    let _selectas = {
      ...selectas,
    };
    _selectas.budget.events[event_i].resources[resource_i][key] = value || null;
    setselectas(_selectas);
  };

  const updateContribution = ({ contribution_i, key, value }) => {
    setselectas({
      ...selectas,
      wallet: {
        ...selectas.wallet,
        contribution: selectas?.wallet?.contribution?.map((__contribution, __contribution_i) => {
          if (__contribution_i === contribution_i) {
            return {
              ...__contribution,
              [key]: value,
            };
          } else {
            return __contribution;
          }
        }),
      },
    });
  };

  const updateRemoval = ({ removal_i, key, value }) => {
    setselectas({
      ...selectas,
      wallet: {
        ...selectas.wallet,
        removal: selectas?.wallet?.removal?.map((__removal, __removal_i) => {
          if (__removal_i === removal_i) {
            return {
              ...__removal,
              [key]: value,
            };
          } else {
            return __removal;
          }
        }),
      },
    });
  };

  const getEventValue = props => {
    const { event_id, package_id, single_id } = props;

    const _number_trainees_event = getTraineesCount({ event_id } || 0)?.event_trainee_spect;
    const _number_trainees_pack = !!package_id
      ? getTraineesCount({ package_id })?.trainee_spect || 0
      : !!single_id
        ? getTraineesCount({ single_id })?.trainee_spect || 0
        : 0;

    const _event = selectas?.budget?.events?.find(__event => __event?.id === event_id) || 0;
    const _cost_event = _event?.resources?.reduce(
      (__resource_acc, __resource) => __resource_acc + (__resource.single_value || 0) * (__resource.qtd || 0),
      0,
    );
    const _cost_event_per_trainee = _cost_event / _number_trainees_event || 0;

    return {
      cost_event: _cost_event,
      cost_per_trainee: _cost_event_per_trainee,
      cost_pack: _cost_event_per_trainee * _number_trainees_pack,
    };
  };

  const getPackageValue = package_id => {
    const _package = selectas?.budget?.packages?.find(__package => __package.id === package_id);
    const _number_trainees = _package?.number_trainees || 0;
    const _trainee_count = _package?.trainee_count || 0;
    const _number_trainees_original = _package?.number_of_trainees_original || 0;

    const _cost_per_trainee = _package?.events?.reduce((__acc_events, __event) => {
      const _event_pack_cost =
        getEventValue({
          event_id: __event.id,
          package_id,
        })?.cost_per_trainee || 0;
      return __acc_events + _event_pack_cost;
    }, 0);

    const _extras_per_trainee = (_package?.advisory || 0) + (_package?.reserve_fund || 0);

    const _total_package = _cost_per_trainee * _number_trainees;
    const _per_trainee = _cost_per_trainee + _extras_per_trainee;
    const _total = _per_trainee * _number_trainees;

    return {
      total_raw: _total_package,
      total: _total,
      per_trainee: _per_trainee || 0,
      total_original: _package?.value_original || 0,
      per_trainee_original: _package?.value_per_trainee_original || 0,
      number_trainees: _number_trainees,
      number_trainees_original: _number_trainees_original,
      trainee_count: _trainee_count,
    };
  };

  const getSingleValue = single_id => {
    const _single = selectas?.budget?.singles?.find(__single => __single.id === single_id);
    const _number_trainees = _single?.number_trainees || 0;
    const _trainee_count = _single?.trainee_count || 0;
    const _number_trainees_original = _single?.number_of_trainees_original || 0;

    const _cost_per_trainee = getEventValue({ single_id, event_id: _single?.event_id })?.cost_per_trainee || 0;
    const _extras_per_trainee = (_single?.advisory || 0) + (_single?.reserve_fund || 0);

    const _total_package = _cost_per_trainee * _number_trainees;
    const _per_trainee = _cost_per_trainee + _extras_per_trainee;
    const _total = _per_trainee * _number_trainees;

    return {
      total_raw: _total_package,
      total: _total,
      per_trainee: _per_trainee || 0,
      total_original: _single?.value_original || 0,
      per_trainee_original: _single?.value_per_trainee_original || 0,
      number_trainees: _number_trainees,
      number_trainees_original: _number_trainees_original,
      trainee_count: _trainee_count,
    };
  };

  const info_valores = (
    <InfoModal
      title="Entenda os Tipos de Valores"
      body={
        <>
          <p>
            <b>Valores do Contrato</b>
          </p>
          <ul>
            <li>Representam os valores oficialmente acordados no momento da assinatura do contrato.</li>
            <li>São fixos e usados para gerar o financeiro dos formandos (boletos, parcelas, etc).</li>
            <li>
              Podem ser atualizados manualmente ao clicar em <b>Atualizar Valores do Contrato</b>, para refletir os
              valores reais mais recentes.
            </li>
            <li>Considera-se no cálculo a quantidade de Formandos do Contrato.</li>
          </ul>
          <p>
            <b>Valores Atuais</b>
          </p>
          <ul>
            <li>
              Refletem a situação real e dinâmica da turma, podendo mudar conforme custos ou número de formandos variam
              ao longo do tempo.
            </li>
            <li>Não afetam o financeiro até que sejam transferidos para os Valores do Contrato.</li>
            <li>Considera-se no cálculo a quantidade de Formandos Esperados.</li>
          </ul>
        </>
      }
    />
  );

  const getTraineesCount = props => {
    const { package_id, single_id, event_id } = props;

    const _budget = selectas?.budget;
    const _single = !!single_id ? _budget?.singles?.find(__single => __single?.id === single_id) : null;
    const _package = !!package_id ? _budget?.packages?.find(__package => __package?.id === package_id) : null;

    const _trainee_spect = _package?.number_trainees || _single?.number_trainees || null;
    const _trainee_count = _package?.trainee_count || _single?.trainee_count || null;

    const _event_id = event_id || _single?.event_id;
    const _event = _budget?.events?.find(__event => __event?.id === _event_id);

    const _trainee_total_event = _event?.number_trainees?.per_package?.reduce(
      (__acc_package, __pack) => {
        const _package_or_single = !!__pack?.package_id
          ? _budget?.packages?.find(__package => __package?.id === __pack?.package_id)
          : _budget?.singles?.find(__single => __single?.event_id === _event?.id);

        return {
          number_trainees: __acc_package?.number_trainees + parseInt(_package_or_single?.number_trainees),
          trainee_count: __acc_package?.trainee_count + parseInt(_package_or_single?.trainee_count),
        };
      },
      { number_trainees: 0, trainees_count: 0 },
    );
    return {
      trainee_spect: parseInt(_trainee_spect) || 0,
      trainee_count: parseInt(_trainee_count) || 0,
      event_trainee_spect: _trainee_total_event?.number_trainees || 0,
      event_trainee_count: _trainee_total_event?.trainee_count || 0,
    };
  };

  return (
    <PrintPage
      has_logo={true}
      header={
        <>
          <h2 style={{ fontSize: "2em", color: "var(--color-primary)" }}>Planilha de Custos</h2>
          <h2 style={{ fontSize: "1.5em" }}>{commercial?.label}</h2>
        </>
      }
    >
      <Main>
        {!loadingPage ? (
          <Content className="-small-font-print" id="group_costs">
            <div>
              <Form>
                <Row className="-hide-on-print">
                  <Col className="d-flex justify-content-between">
                    <div>
                      {commercial && selectas && (
                        <>
                          <h1 className="page-title">
                            {!!selectas.budget.name && `${selectas.budget.name} `}
                            {commercial.budget.data.length > 0 ? (
                              ""
                            ) : (
                              <span className="small-label">(Novo Orçamento)</span>
                            )}
                          </h1>
                          <p style={{ opacity: 0.5, margin: 0 }}>{commercial?.label}</p>
                        </>
                      )}
                    </div>
                    <div className="-hide-on-print">
                      <Button
                        color="primary"
                        onClick={() => {
                          window.print();
                        }}
                      >
                        Imprimir
                      </Button>
                    </div>
                    <span className="-show-on-print" style={{ float: "right" }}>
                      <Logo />
                    </span>
                  </Col>
                </Row>

                <Row className="mt-4 -hide-on-print">
                  <Col>
                    <span>
                      Título <Required />
                    </span>
                    <InputText
                      required={true}
                      placeholder="..."
                      value={selectas?.budget?.name}
                      onChange={__ev => {
                        setselectas({
                          ...selectas,
                          budget: {
                            ...selectas.budget,
                            name: __ev.target.value,
                          },
                        });
                      }}
                    />
                  </Col>
                  <Col>
                    <span>Descrição</span>
                    <InputText
                      placeholder="..."
                      value={selectas?.budget?.description}
                      onChange={__ev => {
                        setselectas({
                          ...selectas,
                          budget: {
                            ...selectas.budget,
                            description: __ev.target.value,
                          },
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <div className="divisor mt-4 mb-3 -hide-on-print"></div>
                        <h3 className="mini-title">Recursos por Eventos</h3>
                        <p className={`small-label mb-2 ${printRules.hide_on_print}`}>
                          Você deve selecionar os recursos e seus valores relacionados aos eventos.
                        </p>
                      </Col>
                    </Row>
                    <Accordion>
                      <Row>
                        <Col>
                          {selectas?.budget?.events?.map((__event, __event_i) => {
                            const _resources =
                              resources?.categories
                                ?.find(__category => __category.id === __event?.category_id)
                                ?.resources?.map(__resource => ({
                                  value: __resource.id,
                                  label: __resource.name,
                                  avaible_supliers:
                                    __resource?.avaible_supliers
                                      ?.filter(__supplier => !!__supplier?.active)
                                      ?.map(__supplier => ({
                                        value: __supplier.id,
                                        label: __supplier.name,
                                      })) || [],
                                })) || [];

                            const _total_trainees =
                              getTraineesCount({
                                event_id: __event.id,
                              })?.event_trainee_spect || 0;

                            return (
                              <React.Fragment key={__event_i}>
                                {(__event.name !== "Sem Eventos" ||
                                  commercial?.custom_payments?.filter(__payment => __payment.event_id === __event.id)
                                    .length > 0) && (
                                  <>
                                    {(__event.id !== null || !!commercial?.is_class) && (
                                      <Accordion.Item
                                        eventKey={`${__event_i + 1}`}
                                        className={`${__event_i > 0 ? "-print-avoid-break" : ""}`}
                                        data-new-component={true}
                                        data-has-error={__event?.resources?.some(
                                          __resource => !__resource?.resource_id,
                                        )}
                                      >
                                        <Accordion.Header
                                          eventKey={`${__event_i + 1}`}
                                          className={styleAccordeon.toggle}
                                        >
                                          <p className={styleAccordeon.title} data-title="true">
                                            {__event.name}
                                            {__event.id !== null && (
                                              <p className="small-label mb-0">
                                                {" "}
                                                <b>{_total_trainees}</b> Formandos Esperados
                                              </p>
                                            )}
                                          </p>
                                          <Accordion.Extras>
                                            {__event.id !== null ? (
                                              <>
                                                <p className="m-0">
                                                  {formatReal(
                                                    __event?.resources?.reduce(
                                                      (__acc, __resource) =>
                                                        __acc + (__resource?.single_value * __resource?.qtd || 0),
                                                      0,
                                                    ) || 0,
                                                    // + (__event.custom_payments?.reduce(
                                                    //   (__acc, __item) => __acc + (__item?.value_total || 0),
                                                    //   0,
                                                    // ) || 0),
                                                  )}
                                                </p>
                                                {__event.number_trainees.total > 0 && (
                                                  <p className="ml-2 mb-0">
                                                    {formatReal(
                                                      (__event.resources?.reduce(
                                                        (__acc, __resource) =>
                                                          __acc + (__resource?.single_value * __resource?.qtd || 0),
                                                        0,
                                                      ) || 0) / _total_trainees,
                                                    )}{" "}
                                                    / formando
                                                  </p>
                                                )}
                                              </>
                                            ) : (
                                              <p className="m-0">
                                                {formatReal(
                                                  commercial?.custom_payments
                                                    ?.filter(__payment => __payment.event_id === null)
                                                    ?.reduce((p2, e2) => p2 + e2.value_total, 0),
                                                )}
                                              </p>
                                            )}
                                          </Accordion.Extras>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          {__event.id !== null && (
                                            <>
                                              {/* <h2 className="mini-title mb-2">
                                                Recursos Gerais <span className="small-label">(Compartilhados)</span>
                                              </h2> */}
                                              <TableResponsive
                                                emptyMsg="Nenhum recurso cadastrado neste evento."
                                                table={{
                                                  head: [
                                                    { data: "Exibir", className: printRules.hide_on_print },
                                                    { data: "Recurso", className: style.resource },
                                                    { data: "Fornecedor", className: style.provider },
                                                    { data: "Quantidade", className: style.qtd },
                                                    { data: "Valor Unit.", className: style.value },
                                                    { data: "Total" },
                                                    { data: "Espec.", className: printRules.hide_on_print },
                                                    { data: "", className: printRules.hide_on_print },
                                                  ],
                                                  body:
                                                    __event.resources.map((__resource, __resource_i) => {
                                                      return {
                                                        show_spoiler: !!__resource?.description,
                                                        data: [
                                                          {
                                                            className: printRules.hide_on_print,
                                                            element: (
                                                              <Checkbox
                                                                checked={__resource?.show}
                                                                onChange={__ev => {
                                                                  updateResource({
                                                                    event_i: __event_i,
                                                                    resource_i: __resource_i,
                                                                    key: "show",
                                                                    value: __ev.target.checked,
                                                                  });
                                                                }}
                                                              />
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <>
                                                                <Slct
                                                                  required={true}
                                                                  placeholder="..."
                                                                  value={__resource?.resource_id}
                                                                  onChange={__ev => {
                                                                    updateResource({
                                                                      event_i: __event_i,
                                                                      resource_i: __resource_i,
                                                                      key: "resource_id",
                                                                      value: __ev.value,
                                                                    });
                                                                  }}
                                                                  options={_resources || []}
                                                                  className={printRules.hide_on_print}
                                                                />
                                                                <p className={printRules.hide_not_print}>
                                                                  {__resource?.name || "-"}
                                                                </p>
                                                              </>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <>
                                                                <Slct
                                                                  placeholder="..."
                                                                  value={__resource?.provider_id}
                                                                  onChange={__ev => {
                                                                    updateResource({
                                                                      event_i: __event_i,
                                                                      resource_i: __resource_i,
                                                                      key: "provider_id",
                                                                      value: __ev.value,
                                                                    });
                                                                  }}
                                                                  options={
                                                                    _resources?.find(
                                                                      __r_f => __r_f?.value === __resource?.resource_id,
                                                                    )?.avaible_supliers || []
                                                                  }
                                                                  className={printRules.hide_on_print}
                                                                />
                                                                <p className={printRules.hide_not_print}>
                                                                  {__resource?.provider_name || "-"}
                                                                </p>
                                                              </>

                                                              //  className={printRules.hide_on_print}
                                                              //       />
                                                              //       <p className={printRules.hide_not_print}>
                                                              //         {__resource?.description || ""}
                                                              //       </p>
                                                              //
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <IntegerNumber
                                                                value={__resource?.qtd}
                                                                valueChange={__ev => {
                                                                  updateResource({
                                                                    event_i: __event_i,
                                                                    resource_i: __resource_i,
                                                                    key: "qtd",
                                                                    value: parseInt(__ev) || null,
                                                                  });
                                                                }}
                                                                maxlength="10"
                                                                placeholder="0"
                                                              />
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <Currency
                                                                value={__resource?.single_value}
                                                                valueChange={__ev => {
                                                                  updateResource({
                                                                    event_i: __event_i,
                                                                    resource_i: __resource_i,
                                                                    key: "single_value",
                                                                    value: __ev || null,
                                                                  });
                                                                }}
                                                              />
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <span className="text-nowrap">
                                                                {formatReal(
                                                                  (__resource?.single_value || 0) *
                                                                    (__resource?.qtd || 0),
                                                                )}
                                                              </span>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <SpoilerLink text="" bold={!!__resource?.description} />
                                                            ),
                                                            className: printRules.hide_on_print,
                                                            id: `description-${__event_i}-${__resource_i}`,
                                                            spoiler: (
                                                              <>
                                                                <InputText
                                                                  placeholder="Descrição"
                                                                  value={__resource?.description}
                                                                  onChange={__ev => {
                                                                    updateResource({
                                                                      event_i: __event_i,
                                                                      resource_i: __resource_i,
                                                                      key: "description",
                                                                      value: __ev.target.value || "",
                                                                    });
                                                                  }}
                                                                  className={printRules.hide_on_print}
                                                                />
                                                                <p className={printRules.hide_not_print}>
                                                                  {__resource?.description || ""}
                                                                </p>
                                                              </>
                                                            ),
                                                          },
                                                          {
                                                            className: printRules.hide_on_print,
                                                            element: (
                                                              <button
                                                                type="button"
                                                                className="simple-ico"
                                                                onClick={() => {
                                                                  let _selectas = {
                                                                    ...selectas,
                                                                  };
                                                                  _selectas.budget.events[__event_i].resources.splice(
                                                                    __resource_i,
                                                                    1,
                                                                  );
                                                                  setselectas(_selectas);
                                                                }}
                                                              >
                                                                <IcLixo />
                                                              </button>
                                                            ),
                                                          },
                                                        ],
                                                      };
                                                    }) || [],
                                                }}
                                              />
                                              <div>
                                                <Button
                                                  size="sm"
                                                  className={printRules.hide_on_print}
                                                  onClick={() => {
                                                    setselectas({
                                                      ...selectas,
                                                      budget: {
                                                        ...selectas.budget,
                                                        events: selectas.budget.events.map((__e, __e_i) => {
                                                          if (__e_i === __event_i) {
                                                            return {
                                                              ...__e,
                                                              resources: [
                                                                ...__e.resources,
                                                                {
                                                                  category_id: __event.category_id,
                                                                  description: "",
                                                                  event_id: __event.id,
                                                                  id: null,
                                                                  provider_id: null,
                                                                  qtd: null,
                                                                  resource_id: null,
                                                                  show: 1,
                                                                  single_value: null,
                                                                },
                                                              ],
                                                            };
                                                          } else {
                                                            return __e;
                                                          }
                                                        }),
                                                      },
                                                    });
                                                  }}
                                                >
                                                  Adicionar Recurso
                                                </Button>
                                              </div>
                                            </>
                                          )}

                                          {commercial?.custom_payments?.filter(
                                            __payment => __payment.event_id === __event.id,
                                          ).length > 0 && (
                                            <>
                                              {__event.id !== null && <div className="divisor mt-4 mb-3"></div>}
                                              <h2 className={`mini-title mb-2 ${__event.id !== null ? "mt-3" : ""}`}>
                                                Itens Adicionais <span className="small-label">(Individuais)</span>
                                              </h2>
                                              <TableResponsive
                                                table={{
                                                  head: [
                                                    { data: "Item" },
                                                    { data: "Aquisição" },
                                                    { data: "Formando" },
                                                    { data: "Valor Unitário" },
                                                    { data: "Quantidade" },
                                                    { data: "Taxa" },
                                                    { data: "Total" },
                                                  ],
                                                  body:
                                                    commercial?.custom_payments
                                                      ?.filter(__payment => __payment.event_id === __event.id)
                                                      .map(__payment => ({
                                                        data: [
                                                          {
                                                            element: (
                                                              <span
                                                                style={{
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {__payment.name}
                                                              </span>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <span
                                                                style={{
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {__payment.payer_type_label}
                                                              </span>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <span
                                                                style={{
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {__payment.trainees?.name}
                                                              </span>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <span
                                                                style={{
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {formatReal(__payment.value || 0)}
                                                              </span>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <span
                                                                style={{
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {__payment.quantity || 0}
                                                              </span>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <span
                                                                style={{
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {formatReal(__payment.convenience_fee || 0)}
                                                              </span>
                                                            ),
                                                          },
                                                          {
                                                            element: (
                                                              <span
                                                                style={{
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {formatReal(
                                                                  (__payment.value || 0) * (__payment.quantity || 0) +
                                                                    __payment.convenience_fee,
                                                                )}
                                                              </span>
                                                            ),
                                                          },
                                                        ],
                                                      })) || [],
                                                }}
                                              />
                                              <Row>
                                                <Col sm={{ span: 4, offset: 8 }}>
                                                  <Results
                                                    rows={[
                                                      {
                                                        label: (
                                                          <>
                                                            Total{" "}
                                                            <span className="small-label">(Itens Adicionais)</span>
                                                          </>
                                                        ),
                                                        value: formatReal(
                                                          commercial?.custom_payments
                                                            ?.filter(__payment => __payment.event_id === __event.id)
                                                            ?.reduce(
                                                              (__acc, __payment) =>
                                                                __acc +
                                                                ((__payment.value || 0) * (__payment.quantity || 0) +
                                                                  __payment.convenience_fee || 0),
                                                              0,
                                                            ) || 0,
                                                        ),
                                                        type: "dark",
                                                      },
                                                    ]}
                                                  />
                                                </Col>
                                              </Row>
                                            </>
                                          )}
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    )}
                                  </>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </Col>
                      </Row>
                    </Accordion>
                  </Col>
                </Row>
                <div className="-print-avoid-break">
                  <Row className="-print-avoid-break">
                    <Col>
                      <div className="divisor mt-4 mb-3"></div>
                      <h2 className="form-title mb-0">Pacotes & Custos Extras</h2>
                      <p className={`small-label mb-3 ${printRules.hide_on_print}`}>
                        Aqui você definirá os valores de Assessoria e Fundo de Reserva. Também visualizará um resumo dos
                        valores de cada pacote e avulsos.
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {commercial && selectas && (
                        <>
                          <TabNotification
                            options={commercial?.packages_data?.packages
                              ?.map(__option => ({
                                id: __option.id,
                                label: __option.name,
                                value: `${__option.trainee_count}/${__option.number_trainees}`,
                                show: true,
                              }))
                              .concat([
                                {
                                  id: -1,
                                  label: "Avulsos",
                                  value: null,
                                  show: !!commercial?.packages_data?.singles?.length,
                                },
                              ])}
                            setActive={setpackagesTab}
                            active={packagesTab}
                            init={null}
                            className="-hide-on-print"
                          />
                          <div className={budgetStyle.tab_content}>
                            <div
                              style={{
                                display: packagesTab === -1 ? "block" : "none",
                              }}
                              className="-package-print"
                            >
                              {selectas?.budget?.singles?.length > 0 && (
                                <>
                                  <div>
                                    <h3 className="form-title">Avulsos</h3>
                                    <p className="small-label">
                                      Quantidade de parcelas possíveis: {commercial.min_payment}x
                                    </p>
                                  </div>
                                  {selectas?.budget?.singles?.map((__single, __single_i) => {
                                    const _trainees_count = getTraineesCount({
                                      single_id: __single?.id,
                                    });
                                    return (
                                      <PackageCard
                                        className={`${__single_i > 0 && "mt-4"}`}
                                        key={`single-${__single.event.id}-${__single_i}`}
                                      >
                                        <ListItem color="dark_ghost">
                                          <span>
                                            <span>
                                              <b>{__single.event.name}</b>
                                            </span>
                                            <p className="small-label mb-0">
                                              <b>{__single.number_trainees}</b> Formandos Esperados
                                            </p>
                                          </span>
                                          <span>
                                            {formatReal(
                                              __single.resources.reduce(
                                                (__total, __resource) =>
                                                  __total +
                                                  ((__resource.single_value * __resource.qtd) /
                                                    _trainees_count?.event_trainee_spect) *
                                                    _trainees_count?.trainee_spect,
                                                0,
                                              ),
                                            )}
                                          </span>
                                        </ListItem>
                                        <ListItem>
                                          <span>
                                            <span>Assessoria</span>
                                            <p className="small-label mb-0">
                                              <b>{__single.number_trainees}</b> Formandos Esperados
                                            </p>
                                          </span>
                                          <span>
                                            <Currency
                                              placeholder="R$ 0,00"
                                              value={__single.advisory || null}
                                              valueChange={ev => {
                                                let _selectas = { ...selectas };
                                                _selectas.budget.singles[__single_i].advisory = ev || null;
                                                setselectas(_selectas);
                                              }}
                                              style={{ textAlign: "right" }}
                                              suffix={" / formando"}
                                              label="Por Formando"
                                            />
                                          </span>
                                        </ListItem>
                                        <ListItem>
                                          <span>
                                            <span>Fundo de Reserva</span>
                                            <p className="small-label mb-0">
                                              <b>{__single.number_trainees}</b> Formandos Esperados
                                            </p>
                                          </span>
                                          <span>
                                            <Currency
                                              label="Por Formando"
                                              placeholder="R$ 0,00"
                                              value={__single.reserve_fund || null}
                                              valueChange={ev => {
                                                let _selectas = { ...selectas };
                                                _selectas.budget.singles[__single_i].reserve_fund = ev || null;
                                                setselectas(_selectas);
                                              }}
                                              style={{ textAlign: "right" }}
                                              suffix={" / formando"}
                                            />
                                          </span>
                                        </ListItem>
                                        <ListItem>
                                          <span>
                                            <span>Quantidade de Formandos</span>
                                          </span>
                                          <div className="d-flex" style={{ maxWidth: "312px" }}>
                                            <span className="mr-2">
                                              <IntegerNumber
                                                placeholder="0"
                                                value={__single.trainee_count || 0}
                                                valueChange={() => {}}
                                                style={{ textAlign: "right" }}
                                                label="Cadastrados"
                                                disabled={true}
                                              />
                                            </span>
                                            <span className="mr-2">
                                              <IntegerNumber
                                                placeholder="0"
                                                disabled={true}
                                                value={__single.number_of_trainees_original}
                                                valueChange={() => {}}
                                                style={{ textAlign: "right" }}
                                                label="Do Contrato"
                                              />
                                            </span>
                                            <span>
                                              <IntegerNumber
                                                required={true}
                                                placeholder="0"
                                                value={__single.number_trainees}
                                                notzero={
                                                  <>
                                                    A quantidade de <b>Formandos Esperados</b> não pode ser menor ou
                                                    igual a zero.
                                                  </>
                                                }
                                                valueChange={__ev => {
                                                  let _selectas = { ...selectas };
                                                  _selectas.budget.singles[__single_i].number_trainees = __ev || null;
                                                  setselectas(_selectas);
                                                }}
                                                style={{ textAlign: "right" }}
                                                label="Esperados"
                                              />
                                            </span>
                                          </div>
                                        </ListItem>
                                        <Row className="mt-4">
                                          {(() => {
                                            const _single_values = getSingleValue(__single?.id);
                                            return (
                                              <>
                                                <Col sm={6}>
                                                  <h3 className="form-title mb-2">
                                                    Valores do Contrato {info_valores}
                                                  </h3>
                                                  <Results
                                                    rows={[
                                                      {
                                                        label: (
                                                          <>
                                                            Total Contrato{" "}
                                                            <span className="small-label">( Avulso )</span>
                                                          </>
                                                        ),
                                                        value: formatReal(_single_values?.total_original || 0),
                                                        type: "dark",
                                                      },
                                                      {
                                                        label: (
                                                          <>
                                                            Por Formando do Contrato{" "}
                                                            <span className="small-label">
                                                              ( <b>{__single?.number_of_trainees_original}</b> )
                                                            </span>
                                                          </>
                                                        ),
                                                        value: formatReal(_single_values?.per_trainee_original || 0),
                                                      },
                                                      {
                                                        label: " ",
                                                        value: (
                                                          <span style={{ opacity: 0.5 }}>
                                                            {commercial.min_payment}x de{" "}
                                                            {formatReal(
                                                              (_single_values?.per_trainee_original || 0) /
                                                                (commercial?.min_payment || 1),
                                                            )}
                                                          </span>
                                                        ),
                                                      },
                                                    ]}
                                                  />
                                                </Col>
                                                <Col sm={6}>
                                                  <h3 className="form-title mb-2">Valores Atuais {info_valores}</h3>
                                                  <Results
                                                    rows={[
                                                      {
                                                        label: (
                                                          <>
                                                            Total Atualizado{" "}
                                                            <span className="small-label">( Avulso )</span>
                                                          </>
                                                        ),
                                                        value: formatReal(_single_values?.total || 0),
                                                        type: "dark",
                                                      },
                                                      // {
                                                      //   label: (
                                                      //     <>
                                                      //       Por Formando Cadastrado
                                                      //       <span className="small-label">
                                                      //         {" "}
                                                      //         ({__single.trainee_count})
                                                      //       </span>
                                                      //     </>
                                                      //   ),
                                                      //   value: formatReal(_single_values?.per_trainee_registered || 0),
                                                      //   type: "transparent",
                                                      // },
                                                      {
                                                        label: (
                                                          <>
                                                            Por Formando Esperado
                                                            <span className="small-label">
                                                              {" "}
                                                              ( <b>{__single.number_trainees}</b> )
                                                            </span>
                                                          </>
                                                        ),
                                                        value: formatReal(_single_values?.per_trainee || 0),
                                                      },
                                                      {
                                                        label: " ",
                                                        value: (
                                                          <span style={{ opacity: 0.5 }}>
                                                            {commercial.min_payment}x de{" "}
                                                            {formatReal(
                                                              (_single_values?.per_trainee || 0) /
                                                                (commercial?.min_payment || 1),
                                                            )}
                                                          </span>
                                                        ),
                                                      },
                                                    ]}
                                                  />
                                                </Col>
                                              </>
                                            );
                                          })()}
                                        </Row>
                                      </PackageCard>
                                    );
                                  })}
                                </>
                              )}
                            </div>
                            {selectas?.budget?.packages?.map((__package, __package_i) => (
                              <div
                                style={{
                                  display: packagesTab === __package.id ? "block" : "none",
                                }}
                                className="-package-print"
                                key={`package-${__package.id}`}
                              >
                                <div>
                                  <h3 className="form-title">{__package.name}</h3>
                                  <p className="small-label">
                                    Quantidade de parcelas possíveis: {commercial.min_payment}x
                                  </p>
                                </div>
                                <PackageCard>
                                  {__package?.events?.map(__event => {
                                    return (
                                      <ListItem key={`event-${__package.id}-${__event.id}`} color="dark_ghost">
                                        <span>
                                          <span>
                                            <b>{__event.name}</b>
                                          </span>
                                          <p className="small-label mb-0">
                                            <b>{__package.number_trainees}</b> Formandos Esperados
                                          </p>
                                        </span>
                                        <span>
                                          {formatReal(
                                            getEventValue({
                                              package_id: __package.id,
                                              event_id: __event.id,
                                            })?.cost_pack || 0,
                                          )}
                                        </span>
                                      </ListItem>
                                    );
                                  })}
                                  <ListItem>
                                    <span>
                                      <span>Assessoria</span>
                                      <p className="small-label mb-0">
                                        <b>{__package.number_trainees}</b> Formandos Esperados
                                      </p>
                                    </span>
                                    <span>
                                      <Currency
                                        label="Por Formando"
                                        placeholder="R$ 0,00"
                                        value={__package.advisory || null}
                                        valueChange={ev => {
                                          let _selectas = { ...selectas };
                                          _selectas.budget.packages[__package_i].advisory = ev || null;
                                          setselectas(_selectas);
                                        }}
                                        style={{ textAlign: "right" }}
                                        suffix={" / formando"}
                                      />
                                    </span>
                                  </ListItem>
                                  <ListItem>
                                    <span>
                                      <span>Fundo de Reserva</span>
                                      <p className="small-label mb-0">
                                        <b>{__package.number_trainees}</b> Formandos Esperados
                                      </p>
                                    </span>
                                    <span>
                                      <Currency
                                        label="Por Formando"
                                        placeholder="R$ 0,00"
                                        value={__package.reserve_fund || null}
                                        valueChange={ev => {
                                          let _selectas = { ...selectas };
                                          _selectas.budget.packages[__package_i].reserve_fund = ev || null;
                                          setselectas(_selectas);
                                        }}
                                        style={{ textAlign: "right" }}
                                        suffix={" / formando"}
                                      />
                                    </span>
                                  </ListItem>
                                  <ListItem>
                                    <span>
                                      <span>Quantidade de Formandos</span>
                                    </span>
                                    <div className="d-flex" style={{ maxWidth: "312px" }}>
                                      <span className="mr-2">
                                        <IntegerNumber
                                          placeholder="0"
                                          value={__package.trainee_count || 0}
                                          valueChange={() => {}}
                                          style={{ textAlign: "right" }}
                                          label="Cadastrados"
                                          disabled={true}
                                        />
                                      </span>
                                      <span className="mr-2">
                                        <IntegerNumber
                                          placeholder="0"
                                          disabled={true}
                                          value={__package.number_of_trainees_original}
                                          valueChange={() => {}}
                                          style={{ textAlign: "right" }}
                                          label="Do Contrato"
                                        />
                                      </span>
                                      <IntegerNumber
                                        required={true}
                                        placeholder={"0"}
                                        value={__package.number_trainees}
                                        valueChange={__ev => {
                                          let _selectas = { ...selectas };
                                          _selectas.budget.packages[__package_i].number_trainees = __ev || null;
                                          setselectas(_selectas);
                                        }}
                                        style={{ textAlign: "right" }}
                                        label="Esperados"
                                        notzero={
                                          <>
                                            A quantidade de <b>Formandos Esperados</b> não pode ser menor ou igual a
                                            zero.
                                          </>
                                        }
                                      />
                                    </div>
                                  </ListItem>
                                  <Row className="mt-4">
                                    {(() => {
                                      const _package_values = getPackageValue(__package?.id);
                                      return (
                                        <>
                                          <Col sm={6}>
                                            <h3 className="form-title mb-2">Valores do Contrato {info_valores}</h3>
                                            <Results
                                              rows={[
                                                {
                                                  label: (
                                                    <>
                                                      Total Contrato <span className="small-label"> ( Pacote )</span>
                                                    </>
                                                  ),
                                                  value: formatReal(_package_values?.total_original || 0),
                                                  type: "dark",
                                                },
                                                {
                                                  label: (
                                                    <>
                                                      Por Formando do Contrato
                                                      <span className="small-label">
                                                        {" "}
                                                        ( <b>{__package?.number_of_trainees_original || 0}</b> )
                                                      </span>
                                                    </>
                                                  ),
                                                  value: formatReal(_package_values?.per_trainee_original || 0),
                                                },
                                                {
                                                  label: " ",
                                                  value: (
                                                    <span style={{ opacity: 0.5 }}>
                                                      {commercial.min_payment}x de{" "}
                                                      {formatReal(
                                                        (_package_values?.per_trainee_original || 0) /
                                                          (commercial?.min_payment || 1),
                                                      )}
                                                    </span>
                                                  ),
                                                },
                                              ]}
                                            />
                                          </Col>
                                          <Col sm={6}>
                                            <h3 className="form-title mb-2">Valores Atuais {info_valores}</h3>
                                            <Results
                                              rows={[
                                                // {
                                                //   label: (
                                                //     <>
                                                //       Por Formando Cadastrado{" "}
                                                //       <span className="small-label">
                                                //         ({_package_values.trainee_count})
                                                //       </span>
                                                //     </>
                                                //   ),
                                                //   value: formatReal(_package_values?.per_trainee_registered || 0),
                                                //   type: "transparent",
                                                // },
                                                {
                                                  label: (
                                                    <>
                                                      Total Atualizado <span className="small-label">( Pacote )</span>
                                                    </>
                                                  ),
                                                  value: formatReal(_package_values?.total || 0),
                                                  type: "dark",
                                                },
                                                {
                                                  label: (
                                                    <>
                                                      Por Formando Esperado{" "}
                                                      <span className="small-label">
                                                        ( <b>{_package_values.number_trainees}</b> )
                                                      </span>
                                                    </>
                                                  ),
                                                  value: formatReal(_package_values?.per_trainee || 0),
                                                },
                                                {
                                                  label: " ",
                                                  value: (
                                                    <span style={{ opacity: 0.5 }}>
                                                      {commercial.min_payment}x de{" "}
                                                      {formatReal(
                                                        (_package_values?.per_trainee || 0) /
                                                          (commercial?.min_payment || 1),
                                                      )}
                                                    </span>
                                                  ),
                                                },
                                              ]}
                                            />
                                          </Col>
                                        </>
                                      );
                                    })()}
                                  </Row>
                                </PackageCard>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
                {!isNewBudget && (
                  <div className="-print-avoid-break">
                    <Row className="mb-2">
                      <Col>
                        <div className="divisor mt-4 mb-3"></div>
                        <h3 className="mini-title">Aportes & Retiradas</h3>
                        <p className="small-label m-0">
                          Caso o aporte não seja benefício de todos os formandos, selecione os beneficiados.
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <Accordion>
                          <Accordion.Item eventKey="aportes">
                            <Accordion.Header>
                              <Tooltip2 tip="Usar no Cálculo do Financeiro">
                                <div className="d-flex align-items-center">
                                  <Checkbox
                                    colorScheme="accordion"
                                    checked={!!selectas?.budget?.aporte}
                                    onChange={__ev => {
                                      setselectas({
                                        ...selectas,
                                        budget: {
                                          ...selectas.budget,
                                          aporte: __ev.target.checked,
                                        },
                                      });
                                    }}
                                  />
                                </div>
                              </Tooltip2>
                              <span className="ml-2">
                                Aportes{" "}
                                <p className="small-label mb-0">
                                  {!!selectas?.budget?.aporte ? "Está" : "Não está"} fazendo parte do cálculo do
                                  financeiro
                                </p>
                              </span>
                              <Accordion.Extras>
                                <p className="m-0">
                                  {selectas &&
                                    formatReal(selectas.wallet.contribution.reduce((p2, e2) => p2 + e2.cost, 0))}
                                </p>
                              </Accordion.Extras>
                            </Accordion.Header>
                            <Accordion.Body>
                              <TableResponsive
                                emptyMsg="Nenhum aporte cadastrado."
                                table={{
                                  head: [
                                    { data: "Tipo" },
                                    { data: "Descrição" },
                                    { data: "Data" },
                                    { data: "Valor" },
                                    { data: "Protocolo" },
                                    { data: "" },
                                  ],
                                  body:
                                    selectas?.wallet?.contribution?.map((__contribution, __contribution_i) => ({
                                      key: `contribution-${__contribution?.id}`,
                                      data: [
                                        {
                                          element: (
                                            <InputText
                                              placeholder="Tipo de Aporte"
                                              value={__contribution?.type}
                                              onChange={__ev => {
                                                updateContribution({
                                                  contribution_i: __contribution_i,
                                                  key: "type",
                                                  value: __ev.target.value || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <InputText
                                              placeholder="Descrição"
                                              value={__contribution?.description}
                                              onChange={__ev => {
                                                updateContribution({
                                                  contribution_i: __contribution_i,
                                                  key: "description",
                                                  value: __ev.target.value || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <DatePicker
                                              className="form-control w-100"
                                              selected={__contribution?.due_date || ""}
                                              changeDate={__ev => {
                                                updateContribution({
                                                  contribution_i: __contribution_i,
                                                  key: "due_date",
                                                  value: __ev || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <Currency
                                              value={__contribution?.cost || ""}
                                              valueChange={__ev => {
                                                updateContribution({
                                                  contribution_i: __contribution_i,
                                                  key: "cost",
                                                  value: __ev || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <IntegerNumber
                                              value={__contribution?.protocol_attendance}
                                              valueChange={__ev => {
                                                updateContribution({
                                                  contribution_i: __contribution_i,
                                                  key: "protocol_attendance",
                                                  value: __ev || "",
                                                });
                                              }}
                                              maxlength="10"
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <button
                                              type="button"
                                              className="simple-ico"
                                              onClick={() => {
                                                let _selectas = { ...selectas };
                                                _selectas.wallet.contribution.splice(__contribution_i, 1);
                                                setselectas(_selectas);
                                                setcontributionToDelete([...contributionToDelete, __contribution?.id]);
                                              }}
                                            >
                                              <IcLixo />
                                            </button>
                                          ),
                                        },
                                      ],
                                      extraRow: [
                                        {
                                          type: "select",
                                          props: {
                                            placeholder: "Todos os Formandos",
                                            isMulti: true,
                                            value: __contribution.trainees || [],
                                            options: commercial?.trainees
                                              ?.filter(__trainee => !__trainee.cancel)
                                              ?.map(__trainee => ({
                                                value: __trainee.id,
                                                label: __trainee.name,
                                              })),
                                            onChange: __ev => {
                                              updateContribution({
                                                contribution_i: __contribution_i,
                                                key: "trainees",
                                                value: __ev || "",
                                              });
                                            },
                                          },
                                        },
                                      ],
                                    })) || [],
                                }}
                              />
                              <Row className="mt-2">
                                <Col sm={{ span: 4, offset: 8 }}>
                                  <div className={budgetStyle.destaque}>
                                    <p>Total de Aportes</p>
                                    <p>
                                      {selectas &&
                                        formatReal(selectas.wallet.contribution.reduce((p2, e2) => p2 + e2.cost, 0))}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                              <div>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setselectas({
                                      ...selectas,
                                      wallet: {
                                        ...selectas.wallet,
                                        contribution: [
                                          ...selectas.wallet.contribution,
                                          {
                                            cost: 0,
                                            type: "",
                                            description: "",
                                            due_date: "",
                                            protocol_attendance: "",
                                            user_id: me.id,
                                          },
                                        ],
                                      },
                                    });
                                  }}
                                  className={`mt-2 ${styleButton.button_success_soft} -hide-on-print`}
                                >
                                  <span>Adicionar Aporte</span>
                                </button>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12}>
                        <Accordion>
                          <Accordion.Item eventKey="retiradas">
                            <Accordion.Header>
                              <div className={styleAccordeon._onlyTitle}>
                                <Tooltip2 tip="Usar no Cálculo do Financeiro">
                                  <div className="d-flex align-items-center">
                                    <Checkbox
                                      colorScheme="accordion"
                                      checked={!!selectas?.budget?.retirada}
                                      onChange={__ev => {
                                        setselectas({
                                          ...selectas,
                                          budget: {
                                            ...selectas.budget,
                                            retirada: __ev.target.checked,
                                          },
                                        });
                                      }}
                                    />
                                  </div>
                                </Tooltip2>
                                <span className="ml-2">
                                  Retiradas{" "}
                                  <p className="small-label mb-0">
                                    {!!selectas?.budget?.retirada ? "Está" : "Não está"} fazendo parte do cálculo do
                                    financeiro
                                  </p>
                                </span>
                                <Accordion.Extras>
                                  <p className="m-0">
                                    {selectas &&
                                      formatReal(selectas.wallet.removal.reduce((p2, e2) => p2 + e2.cost, 0))}
                                  </p>
                                </Accordion.Extras>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <TableResponsive
                                emptyMsg="Nenhuma retirada cadastrada."
                                table={{
                                  head: [
                                    { data: "Tipo" },
                                    { data: "Descrição" },
                                    { data: "Data" },
                                    { data: "Valor" },
                                    { data: "Protocolo" },
                                    { data: "" },
                                  ],
                                  body:
                                    selectas?.wallet?.removal?.map((__removal, __removal_i) => ({
                                      data: [
                                        {
                                          element: (
                                            <InputText
                                              placeholder="Tipo de Retirada"
                                              value={__removal?.type}
                                              onChange={__ev => {
                                                updateRemoval({
                                                  removal_i: __removal_i,
                                                  key: "type",
                                                  value: __ev.target.value || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <InputText
                                              placeholder="Descrição"
                                              value={__removal?.description}
                                              onChange={__ev => {
                                                updateRemoval({
                                                  removal_i: __removal_i,
                                                  key: "description",
                                                  value: __ev.target.value || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <DatePicker
                                              className="form-control w-100"
                                              selected={__removal?.due_date || ""}
                                              changeDate={__ev => {
                                                updateRemoval({
                                                  removal_i: __removal_i,
                                                  key: "due_date",
                                                  value: __ev || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <Currency
                                              value={__removal?.cost || ""}
                                              valueChange={__ev => {
                                                updateRemoval({
                                                  removal_i: __removal_i,
                                                  key: "cost",
                                                  value: __ev || "",
                                                });
                                              }}
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <IntegerNumber
                                              value={__removal?.protocol_attendance}
                                              valueChange={__ev => {
                                                updateRemoval({
                                                  removal_i: __removal_i,
                                                  key: "protocol_attendance",
                                                  value: __ev || "",
                                                });
                                              }}
                                              maxlength="10"
                                            />
                                          ),
                                        },
                                        {
                                          element: (
                                            <button
                                              type="button"
                                              className="simple-ico"
                                              onClick={() => {
                                                let _selectas = { ...selectas };
                                                _selectas.wallet.removal.splice(__removal_i, 1);
                                                setselectas(_selectas);

                                                setremovalToDelete([...removalToDelete, __removal?.id]);
                                              }}
                                            >
                                              <IcLixo />
                                            </button>
                                          ),
                                        },
                                      ],
                                    })) || [],
                                }}
                              />
                              <Row className="mt-2">
                                <Col sm={{ span: 4, offset: 8 }}>
                                  <div className={budgetStyle.destaque}>
                                    <p>Total de Retiradas</p>
                                    <p>
                                      {selectas &&
                                        formatReal(selectas.wallet.removal.reduce((p2, e2) => p2 + e2.cost, 0))}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                              <div>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setselectas({
                                      ...selectas,
                                      wallet: {
                                        ...selectas.wallet,
                                        removal: [
                                          ...selectas.wallet.removal,
                                          {
                                            cost: 0,
                                            type: "",
                                            description: "",
                                            due_date: "",
                                            protocol_attendance: "",
                                            user_id: me.id,
                                          },
                                        ],
                                      },
                                    });
                                  }}
                                  className={`mt-2 ${styleButton.button_success_soft} -hide-on-print`}
                                >
                                  <span>Adicionar Retirada</span>
                                </button>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Col>
                    </Row>
                  </div>
                )}
                <Row className="mt-4">
                  <Col sm={6}>
                    {/* <h4 className="form-title mb-2">Valores do Contrato {info_valores}</h4>
                    <Results
                      rows={[
                        {
                          label: "Total Sonelidades",
                          value: selectas && formatReal(0),
                          type: "dark",
                        },
                        {
                          label: <>Total Sonelidades {<span className="small-label">(Por Formando)</span>}</>,
                          value: formatReal(0),
                        },
                      ]}
                    />
                    <div class="small-label mt-2">
                      Outros modificadores não aparecem nessa lista pois são dinâmicos e variam conforme negociações:
                      individuais.
                    </div> */}
                  </Col>
                  <Col sm={6}>
                    <h3 className="form-title mb-2">Resumo Atualizado {info_valores}</h3>
                    {(() => {
                      const _total_events =
                        selectas.budget.events.reduce(
                          (p, e) =>
                            p + e.resources.reduce((p2, e2) => p2 + (e2?.single_value || 0) * (e2?.qtd || 0), 0),
                          0,
                        ) +
                          selectas.budget.packages.reduce(
                            (p, e) => p + ((e.advisory || 0) + (e?.reserve_fund || 0)) * (e?.number_trainees || 0),
                            0,
                          ) +
                          selectas.budget.singles.reduce(
                            (p, e) => p + ((e.advisory || 0) + (e?.reserve_fund || 0)) * (e?.number_trainees || 0),
                            0,
                          ) || 0;

                      // const _total_aditionals =
                      //   commercial?.custom_payments?.reduce((p, e) => p + e.value_total, 0) || 0;

                      const _total_contributions = selectas.wallet.contribution.reduce((p, e) => p + e.cost, 0) || 0;

                      const _total_removals = selectas.wallet.removal.reduce((p, e) => p + e.cost, 0) || 0;

                      const _total_espected =
                        _total_events -
                        (!!selectas?.budget?.aporte ? _total_contributions : 0) +
                        (!!selectas?.budget?.retirada ? _total_removals : 0);
                      // const _total_espected =
                      //   _total_events + _total_aditionals - _total_contributions + _total_removals;

                      const _total_generated = generatedValues?.totalGeneratedRaw?.totalGeneratedRaw || 0;
                      const _total_paid = generatedValues?.totalPaid?.totalPaidRaw || 0;
                      const _total_juros = generatedValues?.totalJurosInCancelPayments?.totalJuros || 0;
                      const _total_discount = generatedValues?.totalDiscount || 0;
                      const _total_discount_in_payments =
                        generatedValues?.TotalAmountsExtraValuesPerCommercial?.totalDiscount || 0;

                      const _total_generated_after_discount =
                        _total_generated - _total_juros - _total_discount_in_payments;

                      const _financial_result = _total_espected - _total_generated_after_discount - _total_discount;

                      const _total_paid_after_juros_and_discounts =
                        _total_paid - _total_juros - _total_discount_in_payments;

                      return (
                        <Results
                          rows={[
                            {
                              label: "Custo Sonelidades",
                              value: selectas && formatReal(_total_events),
                              type: "dark",
                            },
                            ...(selectas?.budget?.aporte
                              ? [
                                  {
                                    label: "Aportes",
                                    value: `- ${selectas && formatReal(_total_contributions)}`,
                                  },
                                ]
                              : []),
                            ...(selectas?.budget?.retirada
                              ? [
                                  {
                                    label: "Retiradas",
                                    value: `+ ${selectas && formatReal(_total_removals)}`,
                                  },
                                ]
                              : []),
                            ...(selectas?.budget?.retirada || selectas?.budget?.aporte
                              ? [
                                  {
                                    label: <b>Total Esperado</b>,
                                    value: formatReal(_total_espected),
                                    type: "dark",
                                  },
                                ]
                              : []),
                            {
                              label: <>Bônus e Promoções (Contratados)</>,
                              value: formatReal(-1 * _total_discount),
                              type: "transparent",
                            },
                            {
                              label: (
                                <>
                                  Total Gerado <TotalGenerate title="Total Gerado" commercialId={commercialId} />
                                </>
                              ),
                              value: formatReal(_total_generated_after_discount),
                            },
                            {
                              label: <b>Resultado Financeiro</b>,
                              value: `${formatReal(-1 * _financial_result)}`,
                              type: "dark",
                            },
                            {
                              label: (
                                <>
                                  Total Pago <TotalPaid title="Total Pago" commercialId={commercialId} />
                                </>
                              ),
                              value: formatReal(_total_paid_after_juros_and_discounts),
                              type: "transparent",
                            },
                          ]}
                        />
                      );
                    })()}
                    <div class="small-label mt-2">
                      Total Gerado e Total Pago não contabilizam descontos de negociação (somente Bônus e Promoções),
                      taxas, multas e juros.
                    </div>
                  </Col>
                </Row>
                <Row className="inner-page__actions mt-5 -hide-on-print">
                  <Col className="d-flex justify-content-end">
                    <div>
                      <Button
                        color="primary"
                        onClick={() => {
                          const _is_valid = validateForm(document.getElementById("group_costs"));
                          if (!_is_valid) return;

                          setshowModalUpdate(true);
                        }}
                      >
                        Atualizar Valores Contratados
                      </Button>
                      <Button
                        color="primary"
                        onClick={() => {
                          const _is_valid = validateForm(document.getElementById("group_costs"));
                          if (!_is_valid) return;

                          setshowModalSubmit(true);
                        }}
                      >
                        Salvar Planilha
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}

        <ModalConfirm
          disableClick={disableModalClick}
          loading={disableModalClick}
          show={showModalSubmit}
          title="Salvar Planilha"
          text="Deseja salvar as atualizações desta planilha?"
          confirm={() => {
            confirmSubmit({ update_values: false });
          }}
          closeModal={() => {
            setshowModalSubmit(false);
          }}
          colorScheme="primary"
        />
        <ModalConfirm
          disableClick={disableModalClick}
          loading={disableModalClick}
          show={showModalUpdate}
          title="Salvar e Atualizar Valores Contratados"
          confirmText="Atualizar Valores"
          text={
            <>
              <p>
                <b>ATENÇÃO:</b>
              </p>
              <p>
                Ao confirmar esta ação, os <b>Valores Atuais</b> serão copiados para os <b>Valores do Contrato</b>,
                tornando-os os novos valores oficiais da turma.
              </p>
              <p>
                Isso impactará diretamente o financeiro de todos os formandos, pois será necessário{" "}
                <b>Renegociar o Financeiro</b> ou <b>Gerar Difrença</b> para que as parcelas futuras considerem os novos
                custos e a nova quantidade de formandos.
              </p>
              <p>
                Recomenda-se realizar esta atualização apenas quando os valores e a turma estiverem definidos com
                segurança.
              </p>
              <p>
                <b>Deseja continuar?</b>
              </p>
            </>
          }
          confirm={() => {
            confirmSubmit({ update_values: true });
          }}
          closeModal={() => {
            setshowModalUpdate(false);
          }}
          colorScheme="primary"
        />
      </Main>
    </PrintPage>
  );
}
